import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import getFilename from '../utils/getFilename';
import downloadFile, { FileType, Target } from '../utils/downloadFile';
import handleServiceError from '../utils/handleServiceError';

const downloadAppleWalletPass = async (booking: SelfServiceAPI.Booking, options: Options = {}): Promise<void> => {
  try {
    const { headers, data } = await api.get(booking.links.downloadAppleWalletPass, {
      url: booking.links.downloadAppleWalletPass,
      responseType: 'blob',
    });

    const filename = getFilename(headers);
    downloadFile(filename || `${booking.reference}.pkpass`, data, FileType['application/vnd.apple.pkpass'], Target['_blank']);
  } catch (error) {
    handleServiceError(error, {
      operationName: `GET ${booking.links.downloadAppleWalletPass}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default downloadAppleWalletPass;
